export const ERROR_CONNECT_TOOL_USB =
  "Lỗi kết nối. Vui lòng kiểm tra lại file kết nối và ấn restart lại";
export const ERROR_GET_INFO_USB =
  "Không lấy dc thông tin USB token. Vui lòng kiểm tra lại USB và ấn Recheck";
export const GET_INFO_USB = "Đang lấy thông tin USB token";

export const FIELD_EXTRA = {
  FIELD_EMPTY: {
    field: "FIELD_EMPTY",
  },
};

export const TAX_DEDUCT_COMMON_FIELD = {
  TEN_DVI: {
    field: "tnnt", // Tên đơn vị phát hành biên lai
    type: "text",
    max: 50,
    required: false,
    widthLabel: "201px",
  },
  MST: {
    field: "mst", // Mã số thuế
    isTaxCode: true,
    type: "text",
    max: 14,
    widthLabel: "201px",
    // xs: 4,
  },
  DIACHI: {
    field: "dchi", // Địa chỉ trụ sở chính
    type: "text",
    max: 50,
    required: false,
    widthLabel: "201px",
  },
  SDT: {
    field: "sdthoai", // Điện thoại
    type: "text",
    max: 50,
    required: false,
    widthLabel: "201px",
  },
  LOAI_BIEN_LAI: {
    field: "cldldphanh", // Các loại biên lai đã phát hành
    type: "text",
    max: 50,
    required: false,
    widthLabel: "201px",
  },
  TEN_CQT: {
    field: "cqtqly", // Tên cơ quan thuế tiếp nhận thông báo
    type: "select",
    required: false,
    widthLabel: "201px",
    styleCol: {
      zIndex: "999",
    },
  },
  NLAP: {
    field: "nlap",
    type: "date",
  },
  MSO: {
    field: "mso",
    type: "text",
    defaultValue: "02/PH-BLG",
  },
  TEN: {
    field: "ten",
    type: "text",
    defaultValue: "THÔNG BÁO PHÁT HÀNH BIÊN LAI ĐẶT IN, TỰ IN",
  },
};

// Danh sách hàng hóa dịch vụ
export const LIST_LOAI_BIEN_FIELD = {
  HHDV_OBJ: {
    field: "blai",
    type: "field_array",
    fieldReal: "blai",
    list: {
      TEN: {
        field: "tlblai", // Tên loại biên lai
        fieldReal: "tlblai",
        type: "text",
        max: 50,
        width: "200px",
        required: false,
      },
      KHM: {
        field: "khmblai", // Ký hiệu mẫu biên lai
        fieldReal: "khmblai",
        type: "text",
        max: 50,
        width: "200px",
        required: false,
      },
      KH: {
        field: "khblai", // Ký hiệu biên lai
        fieldReal: "khblai",
        type: "text",
        max: 50,
        width: "200px",
        required: false,
      },
      SL: {
        field: "sluong", // Số lượng
        fieldReal: "sluong",
        type: "number",
        max: 50,
        width: "200px",
        required: false,
      },
      TU_SO: {
        field: "tso", // Từ số
        fieldReal: "tso",
        type: "number",
        max: 50,
        width: "200px",
        required: false,
      },
      DEN_SO: {
        field: "dso", // Đến số
        fieldReal: "dso",
        type: "number",
        max: 50,
        width: "200px",
        required: false,
      },
      NGAY_BAT_DAU_SU_DUNG: {
        field: "nbdsdung", // Ngày bắt đầu sử dụng
        fieldReal: "nbdsdung",
        type: "date",
        max: 50,
        width: "200px",
        required: false,
      },
      SO_HD_CUNG_UNG: {
        field: "hdong", // Hợp đồng in/Hợp đồng cung ứng phần mềm tự in biên lai số....ngày....
        fieldReal: "hdong",
        type: "text",
        max: 50,
        width: "200px",
        required: false,
      },
      TEN_DN_CUNG_UNG: {
        field: "ttcgp", // Tên doanh nghiệp cung ứng phần mềm in biên lai
        fieldReal: "ttcgp",
        type: "text",
        max: 50,
        width: "200px",
        required: false,
      },
      MST_DN_CUNG_UNG: {
        field: "msttcgp", // MST doanh nghiệp cung ứng phần mềm in biên lai
        fieldReal: "msttcgp",
        type: "text",
        max: 14,
        width: "200px",
        isTaxCode: true,
        required: false,
      },
    },
  },
};
